import React from "react";
import { List, ListItem, Grid, Typography, Divider } from "@mui/material";
import { WorkOrder } from "@/__generated__/graphql";

type Props = {
  workOrders: WorkOrder[];
};

const WorkOrders = ({ workOrders }: Props) => {
  return (
    <List>
      {workOrders.map((workOrder, index) => (
        <>
          <ListItem key={index}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Typography variant="caption">Work Order Number</Typography>
                <Typography variant="body1">{workOrder?.workOrderNumber}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption">POI</Typography>
                <Typography variant="body1">{workOrder?.poiName}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption">Status</Typography>
                <Typography variant="body1">{workOrder?.status || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption">Status Updated At</Typography>
                <Typography variant="body1">
                  {workOrder.statusUpdatedAt ? new Date(Number(workOrder.statusUpdatedAt)).toLocaleString() : 'N/A'}
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
          <Divider style={{ margin: "1rem 0" }} />
        </>
      ))}
    </List>
  );
};

export default WorkOrders;
